import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Clipboard(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M22 2a2 2 0 012 2h4a2 2 0 012 2v26a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2h4a2 2 0 012-2h8zM12 5H8a1 1 0 00-.993.883L7 6v26a1 1 0 00.883.993L8 33h20a1 1 0 00.993-.883L29 32V6a1 1 0 00-.883-.993L28 5h-4a2 2 0 01-2 2h-8a2 2 0 01-2-2zm4.266 10.745l.04.087L19.18 23.9l2.114-3.133a.498.498 0 01.316-.21l.098-.01H26a.5.5 0 01.09.992l-.09.008-4.025-.001-2.52 3.735a.5.5 0 01-.846-.029l-.039-.083-2.743-7.703-1.387 3.754a.5.5 0 01-.38.319l-.089.008H10a.5.5 0 01-.09-.992l.09-.008 3.623-.001 1.743-4.718a.5.5 0 01.9-.082zM22 3h-8a1 1 0 00-.993.883L13 4v1a1 1 0 00.883.993L14 6h8a1 1 0 00.993-.883L23 5V4a1 1 0 00-.883-.993L22 3z"></path>
    </IconSvg>
  );
}
